// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"vq","imageWrapper":"vr","image":"vs","imageInCenter":"vt","ctaWrapper":"vu","copyright":"vv","rentalBadge":"vw","sideGradient":"vx","bottomGradient":"vy"};